import { ReactNode } from 'react'
import { Navbar } from '@/app/entities/navbar/ui/Navbar'
import { Drawer } from '@/common/ui/Drawer'
import { Outlet } from 'react-router-dom'
import { ProfileMenu } from '@/app/entities/profileMenu/ui/ProfileMenu'
import { NavbarMobileMenu } from '@/app/entities/navbar/ui/Navbar'
import { ToastProvider, ToastViewport } from '@/common/ui/Toast/ToastProvider'
import { IncompleteProfileToastListener } from '@/common/entities/me/lib/IncompleteProfileToastListener'
import { SelectPortalRoot } from '@/common/ui/Form/Select'
import { PaymentResultModal } from '@/app/entities/paymentResult'

interface ProfileLayoutProps {
    children?: ReactNode
}

export const ProfileLayout = ({ children }: ProfileLayoutProps) => {
    return (
        <ToastProvider>
            <IncompleteProfileToastListener />
            <Drawer menu={<ProfileMenu topSlot={<NavbarMobileMenu />} />} id='my-drawer-1'>
                <div className='flex justify-center min-w-[370px]'>
                    <div className='min-h-screen max-w-7xl bg-base-100 flex-1'>
                        <Navbar />
                        <div className='mb-[4rem] mt-[1.938rem] px-[1.25rem]'>
                            <div className='flex flex-col lg:flex-row lg:gap-5'>
                                <div className='hidden lg:block lg:w-[19.125rem] lg:shrink-0 sticky top-[5.7rem] self-start'>
                                    <ProfileMenu />
                                </div>
                                <div className='profile min-w-0 flex-1'>{children || <Outlet />}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <SelectPortalRoot />
                <ToastViewport />
            </Drawer>
            <PaymentResultModal />
        </ToastProvider>
    )
}

export default ProfileLayout
